import client from './client';
import { DashboardStats, TimelineEvent, Notification } from '../types';

export interface ScoreRhModule {
  name: string;
  score: number;
  detail: string;
}

export interface ScoreRhData {
  score: number;
  label: string;
  health: 'good' | 'fair' | 'low' | 'critical';
  modules: ScoreRhModule[];
  recommendations: string[];
  stats?: Record<string, number>;
}

export const dashboardApi = {
  stats: () => client.get<DashboardStats>('/dashboard/stats'),

  scoreRh: () =>
    client.get<{ success: boolean; data: ScoreRhData }>('/dashboard/score-rh'),

  alerts: () => client.get<Notification[]>('/dashboard/alerts'),

  timeline: () => client.get<TimelineEvent[]>('/dashboard/timeline'),

  notifications: () => client.get('/dashboard/alerts'),

  markRead: (id: string) => client.put(`/dashboard/notifications/${id}/read`),

  markAllRead: () => client.put('/dashboard/notifications/read-all'),
};
